<ng-container *ngIf="screenSize === 'desktop'; else mobileTemplate">
  <app-order-desktop></app-order-desktop>
</ng-container>

<ng-template #mobileTemplate>
  <app-order-mobile></app-order-mobile>
</ng-template>
